/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'

const BASE_URL = 'paas'
export default {
  /**
   * @description 获取个体户-列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getIndividualList(data) {
    return request.get(`/${BASE_URL}/individual/list`, data)
  },

  /**
   * @description 获取个体户-详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getIndividualInfo(data) {
    return request.post(`/${BASE_URL}/individual/get_info`, data)
  },

  /**
   * @description 获取个体户-删除
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  individualDelete(data) {

    return request.Delete(`/${BASE_URL}/individual/delete`, data)
  },

  /**
   * @description 发票代开-删除
   * @author YQ
   * @date 2021-07-21
   * @param {*} data
   * @returns
   */
  invoicingDelete(data) {
    return request.Delete(`/${BASE_URL}/invoice_agent/delete`, data)
  },

  /**
   * @description 获取个体户-办理
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  individualAudit(data) {
    return request.put(`/${BASE_URL}/individual/audit`, data)
  }

}